import moment from 'moment'

export default CookiesService

/** @ngInject */
function CookiesService($cookies, $rootScope) {
    const checkCookiesAcceptance = () => $cookies.get('plumAuthorizeCookies')

    const acceptCookies = function () {
        $cookies.put('plumAuthorizeCookies', true, { expires: moment.utc(moment().add(5, 'years'))._d })
        return $rootScope.$emit('cookiesAccepted')
    }

    $rootScope.$on('$stateChangeStart', () => {
        if (!checkCookiesAcceptance()) {
            return acceptCookies()
        }
    })

    return {
        checkCookiesAcceptance,
        acceptCookies,
    }
}



// WEBPACK FOOTER //
// ./src/services/cookies/service.js